export const getCurrentUser = () => {
  return {
    id: ('; ' + document.cookie).split(`; current_user_id=`).pop().split(';')[0],
    email: ('; ' + document.cookie).split(`; current_user_email=`).pop().split(';')[0].replace('%40', '@'),
    name: ('; ' + document.cookie).split(`; current_user_name=`).pop().split(';')[0].replaceAll('+', ' '),
  };
};
